import * as React from 'react';
import styled from "styled-components";
import TabBar, {TabBarItem} from "./TabBar";
import TextContentBox from "./TextContentBox";
import TabletSlider from "./TabletSlider";
import ImageNavigation1 from '../../../images/for-students/navigation-1.jpg'
import ImageNavigation2 from '../../../images/for-students/navigation-2.jpg'
import ImageCourse1 from '../../../images/for-students/courses-1.jpg'
import ImageCourse2 from '../../../images/for-students/courses-2.jpg'
import ImageLessons1 from '../../../images/for-students/lessons-1.png'
import ImageTasks1 from '../../../images/for-students/tasks-1.jpg'
import ImageTasks2 from '../../../images/for-students/tasks-2.jpg'
import ImageWebinars1 from '../../../images/for-students/webinars-1.jpg'

const List = styled.ol`
  list-style: none;
  counter-reset: item;
  padding: 0;
  margin: 0;
`;

const ListItem = styled.li`
  counter-increment: item;
  
  &::before {
    content: counter(item) ". ";
    font-weight: 700;
  }
`;

const TabContainer = styled.div`
  display: grid;
  grid-template-columns: 760px 357px;
  gap: 40px;
`;

const Container = styled.div`
  display: grid;
  gap: 20px;
  width: 100%;
  margin-top: 20px;

  @media screen and (max-width: 1270px) {
    ${TabContainer} {
      grid-template-columns: 1fr 357px;
    }
  }

  @media screen and (max-width: 1140px) {
    ${TabContainer} {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
`;

/**
 * render landing page student functional block
 * @constructor
 */
export default function FunctionalStudents(): React.ReactElement {
  const [activeTab, setActiveTab] = React.useState(1)

  const tabs: TabBarItem[] = [
    {num: 1, label: 'Навигация'},
    {num: 2, label: 'Курсы'},
    {num: 3, label: 'Уроки'},
    {num: 4, label: 'Задания'},
    {num: 5, label: 'Трансляции'},
  ];

  function renderTabContent() {
    switch (activeTab) {
      case 1:
        return (
          <TabContainer>
            <TabletSlider
              items={[
                ImageNavigation1,
                ImageNavigation2,
              ]}
            />
            <TextContentBox
              title={tabs[activeTab-1].label}
              number={activeTab}
            >
              <div>
                Для нас важно, насколько студенту комфортно проходить курсы.
                По опыту мы знаем,
                что при первичной продаже практически не имеет значения,
                где будет проходить обучение.
                Но повысив удобство для пользователя,
                мы смогли поднять конверсию в повторную покупку в 3 раза.
              </div>
              <div>
                Реализовать это удалось за счет нескольких вещей:
              </div>
              <List>
                <ListItem>
                  Доступ к контенту с любого устройства в любое время
                </ListItem>
                <ListItem>
                  Удобная навигация и трекинг текущего прогресса
                </ListItem>
                <ListItem>Быстрая смена активного курса</ListItem>
              </List>
            </TextContentBox>
          </TabContainer>
        );
      case 2:
        return (
          <TabContainer>
            <TabletSlider
              items={[
                ImageCourse1,
                ImageCourse2,
              ]}
            />
            <TextContentBox
              title={tabs[activeTab-1].label}
              number={activeTab}
            >
              <div>
                Страница с текущими курсами и прошедшими,
                где скрыто много функционала и сервиса для пользователя:
              </div>
              <List>
                <ListItem>Страница текущих курсов</ListItem>
                <ListItem>Возможность купить пройденный курс повторно</ListItem>
                <ListItem>
                  Страница с Вашими специальными предложениями
                </ListItem>
              </List>
            </TextContentBox>
          </TabContainer>
        );
      case 3:
        return (
          <TabContainer>
            <TabletSlider
              items={[
                ImageLessons1,
              ]}
            />
            <TextContentBox
              title={tabs[activeTab-1].label}
              number={activeTab}
            >
              <div>
                Страница уроков с журнальной версткой
                будет смотреться на любом устройстве потрясающе!
              </div>
            </TextContentBox>
          </TabContainer>
        );
      case 4:
        return (
          <TabContainer>
            <TabletSlider
              items={[
                ImageTasks1,
                ImageTasks2,
              ]}
            />
            <TextContentBox
              title={tabs[activeTab-1].label}
              number={activeTab}
            >
              <div>
                Такой-же удобный менеджемент и создания уроков,
                с тэгами, поиском и демонстрацией
                где используется урок.
                Вы точно теперь не запутаетесь.
              </div>
              <List>
                <ListItem>
                  Создавайте уроки из готовых блоков:
                  мощный текстовый редактор,
                  изображения, видео, галлерея, документы.
                </ListItem>
                <ListItem>
                  Быстрое и удобное
                  добавление материалов из библиотеки
                </ListItem>
                <ListItem>
                  Автоматическое оформление в красивую верстку
                  для вашего пользователя
                </ListItem>
                <ListItem>
                  Удобное расписание и
                  интуитивно-понятная навигация для студента
                </ListItem>
              </List>
            </TextContentBox>
          </TabContainer>
        );
      case 5:
        return (
          <TabContainer>
            <TabletSlider
              items={[
                ImageWebinars1,
              ]}
            />
            <TextContentBox
              title={tabs[activeTab-1].label}
              number={activeTab}
            >
              <div>
                Проводите трансляции без ограничений по времени
                и количеству человек,
                используя встроенный функционал трансляций
                для вебинаров по технологии WebRTC:
                Отличное качество связи и стабильность.
              </div>
              <List>
                <ListItem>
                  Задавайте настройки трансляции
                  и время проведения,
                  добавляйте материалы для проведения
                </ListItem>
                <ListItem>
                  Используйте большой встроенный функционал
                  - есть все, что нужно!
                </ListItem>
                <ListItem>
                  Делайте специальные офферы во время трансляции,
                  предложение появится на экране участника,
                  а также в личном кабинете после трансляции,
                  если вы этого захотите.
                </ListItem>
              </List>
            </TextContentBox>
          </TabContainer>
        );
    }
  }

  return (
    <Container>
      <TabBar
        active={activeTab}
        items={[...tabs]}
        onChange={(tab) => setActiveTab(tab)}
      >
        {renderTabContent()}
      </TabBar>
    </Container>
  );
}
